
export default function (subscription) {
    if (!subscription) {
        return 0;
    }
    const remain = subscription.limit_size - subscription.used;
    if (remain < 0) {
        return 0;
    }
    return remain;
}
